import {
  Box,
  Typography,
  Container,
  Grid,
  Paper
} from "@mui/material";

import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import Equipo from "../../assets/img/gris.png";

const estadisticas = [
  {
    numero: "25+",
    titulo: "Años de trayectoria",
    icono: <SchoolOutlinedIcon />,
    color: "#484a75",
  },
  {
    numero: "850+",
    titulo: "Estudiantes",
    icono: <GroupsOutlinedIcon />,
    color: "#8f1515",
  },
  {
    numero: "98%",
    titulo: "Aprobación",
    icono: <WorkspacePremiumOutlinedIcon />,
    color: "#484a75",
  },
  {
    numero: "100%",
    titulo: "Compromiso",
    icono: <FavoriteBorderOutlinedIcon />,
    color: "#8f1515",
  },
];

// ---------------------------------------
// Animaciones
// ---------------------------------------

const aparecer = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: .8,
    },
  }),
};


export const Introduccion = () => {
  const { ref, inView } = useInView({
  threshold: 0,
  rootMargin: "0px",
  triggerOnce: true,
});


  return (
    <Box
      sx={{
        py: {
          xs: 8,
          md: 14,
        },
        background: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="lg">
      
    
            <Box ref={ref} sx={{mb:3}}>
                <motion.div
  variants={aparecer}
  initial="hidden"
  animate={inView ? "visible":"hidden"}
  custom={0}
>
            <Typography
              sx={{
                fontFamily:'Archivo',
                color: "#C62828",
                fontWeight: 700,
                letterSpacing: 2,
                fontSize: '1.2rem',
                mb: 1,
                textTransform: "uppercase",
              }}
            >
              Quiénes Somos
            </Typography>
            </motion.div>
               <Box
    sx={{
      width: 65,          // Largo del subrayado
      height: 3,
      bgcolor: "#C62828",
      borderRadius: "10px",
      mt: 1.2,
      mb:2
    }}
  />
  
  <motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={1}
>
            <Typography
              sx={{
                fontFamily: "Archivo",
                fontWeight: 600,
                color: "#12213F",
                lineHeight: 0.8,
                fontSize: {
                  xs: "2.4rem",
                  md: "3rem",
                },
              }}
            >
              Formamos personas integras para
            </Typography>
</motion.div>

<motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={2}
>
            <Typography
              sx={{
                fontFamily: "Archivo",
                fontWeight: 600,
                color: "#C62828",
                lineHeight: 1,
                fontSize: {
                  xs: "2.4rem",
                  md: "3rem",
                },
                mb: 4,
              }}
            >
              para un mejor futuro
            </Typography>
</motion.div>
<motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={3}
>
            <Typography
              sx={{
                fontFamily: "Archivo",
                fontWeight: 400,
                color: "#606C80",
                lineHeight: 1.5,
                fontSize: 17,
                maxWidth: 520,
                mb: 5,
              }}
            >
              El Colegio Antilen nace como respuesta al compromiso con la
              educación de nuestra comunidad. Durante más de 25 años hemos
              formado estudiantes con sólidos valores, excelencia académica y
              una visión integral que los prepara para enfrentar los desafíos
              del futuro.
            </Typography>
</motion.div>
<motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={4}
>
          
</motion.div>



          {/* IMAGEN */}

    
    <motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={6}
>
            <Box
  sx={{
    position: "absolute",
    top: 0,
    right: 0,
    width: {
      sm: 180,
      md: 420,
    },
    height: "100%",
    pointerEvents: "none",
    overflow: "hidden",
  }}
>
     <Box
  sx={{
    position: "absolute",

    right: 300,
    top: 20,

    width: 150,
    height: 180,

    backgroundImage:
      "radial-gradient(circle, rgba(216,31,49,.9) 2px, transparent 2px)",

    backgroundSize: "14px 14px",

    opacity: .8,

    maskImage:
      "radial-gradient(circle at center, black 45%, transparent 100%)",

    WebkitMaskImage:
      "radial-gradient(circle at center, black 45%, transparent 100%)",
  }}
/>
             
<Box
  component="img"
  src={Equipo}
  sx={{
    position: "absolute",

    right: -80,
    top: 40,

    width: {
      md: '80%',
      lg: '100%',
    },

    opacity: .3,

    filter: `
      blur(.4px)
      saturate(2)
      contrast(1.15)
    `,

    zIndex: 0,

    /* Se desvanece hacia la izquierda */
    maskImage:
      "linear-gradient(to left, black 55%, rgba(0,0,0,.35) 75%, transparent 100%)",

    WebkitMaskImage:
      "linear-gradient(to left, black 55%, rgba(0,0,0,.35) 75%, transparent 100%)",
  }}
/>       </Box>
            </motion.div>
         
</Box>
        
<motion.div
 variants={aparecer}
 initial="hidden"
 animate={inView ? "visible":"hidden"}
 custom={5}
>
<Paper
  elevation={0}
  sx={{
    mt: 8,
    borderRadius: "28px",
    boxShadow: `
      0px 10px 30px rgba(18, 33, 63, 0.08),
      0px 25px 60px rgba(18, 33, 63, 0.12)
    `,
    overflow: "hidden",
    background: "#fff",
  }}
>

          <Grid container>

            {estadisticas.map((item, index) => (  
  <Grid
                key={item.numero}
                size={{ xs: 6, md: 3 }}
    sx={{
      position: "relative",
      display: "flex",
      justifyContent: "center",
      py: 3,

      "&::after": {
        content: '""',
        position: "absolute",
        top: "18%",
        right: 0,
        width: "1px",
        height: "64%",
        background:
          "linear-gradient(180deg,#8f1515,#561c33,#c69ba5,#e3effb)",
        opacity: .45,
        display: {
          xs: "none",
          md: index === item.length - 1 ? "none" : "block",
        },
      },
    }}
  >
    <motion.div
 initial={{
   opacity:0,
   scale:.85,
   x:80
 }}
 animate={inView ? {
   opacity:1,
   scale:1,
   x:0
 }:{
   opacity:0,
   scale:.85,
   x:80
 }}
 transition={{
   duration:.9,
   ease:[0.22,1,0.36,1]
 }}
>
    <Box
      sx={{
        width: "100%",
        maxWidth: 170,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {/* Icono */}
      <Box
        sx={{
          width: 72,
          height: 72,
          color:'#fff',
          borderRadius: "50%",
          background:
            "linear-gradient(135deg,#8f1515,#561c33,#484a75)",
          border: "3px solid #e3effb",
          boxShadow: "0 12px 25px rgba(72,74,117,.20)",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          transition: ".35s",

          "& svg": {
            fontSize: 34,      // Todos iguales
            width: 34,
            height: 34,
          },

          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 18px 35px rgba(86,28,51,.28)",
          },
        }}
      >
        {item.icono}
      </Box>

      <Typography
        sx={{
          mt: 2.2,
          fontWeight: 700,
          color: "#484a75",
          fontSize: {
            xs: "1.5rem",
            md: "2rem",
          },
        }}
      >
        {item.numero}
      </Typography>

      <Typography
        sx={{
          mt: .5,
          color: "#6b7280",
          fontWeight: 500,
          fontSize: {
            xs: ".82rem",
            md: ".95rem",
          },
          lineHeight: 1.5,
          maxWidth: 120,
          minHeight: 42, // Todos los textos alineados
        }}
      >
        {item.titulo}
      </Typography>
    </Box>
    </motion.div>
  </Grid>
))}
</Grid>
 </Paper>


</motion.div>
      </Container>
    </Box>
  );
};